import {createContext} from 'react';

interface ContextProps {}

export const AppContext = createContext({} as ContextProps);
